import { styled, Typography } from "@mui/material";
import { mainTheme } from "../../../../theme/mainTheme";

type TStatus = {
  status?: "success" | "error" | "pending";
  width?: string;
  height?: string;
};

type LabelVariant = {
  variant?: "icon" | "button";
};

export const FileBlockWrapper = styled("label")<TStatus>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 24px 16px;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "112px"};
  background: #ffffff;
  border: ${({ status = "pending" }) =>
    status === "pending"
      ? `1px dashed ${mainTheme.palette.info.main}`
      : status === "success"
      ? `1px solid ${mainTheme.palette.success.main}`
      : `1px solid ${mainTheme.palette.error.main}`};
  border-radius: 14px;
  cursor: pointer;
  &:hover {
    background: #fafafa;
  }
`;

export const DialogCustomLabel = styled("label")<LabelVariant>`
  display: flex;
  padding: ${({ variant = "button" }) =>
    variant === "button" ? "16px 60px" : "4px"};
  fill: ${({ variant = "button" }) =>
    variant === "button" ? "inherit" : mainTheme.palette.info.main};
  color: ${({ variant = "button" }) =>
    variant === "button" ? "inherit" : mainTheme.palette.info.main};
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const FileLabelInput = styled(Typography)<TStatus>`
  margin-right: 34px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  color: ${({ status }) =>
    status === "pending"
      ? mainTheme.palette.info.main
      : status === "success"
      ? "#1C1F21"
      : mainTheme.palette.error.main};
`;

export const FileLabelSubtitle = styled(Typography)<TStatus>`
  margin-right: 34px;
  margin-top: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  color: ${mainTheme.palette.info.main};
`;

export const FileLabelInputLine = styled(Typography)<TStatus>`
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
`;

export const FileSubLabelInput = styled(Typography)<{ isActive?: boolean }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
  color: ${({ isActive }) =>
    isActive ? mainTheme.palette.success.main : mainTheme.palette.error.main};
`;

export const ImageFile = styled("img")`
  max-width: 127px;
  max-height: 80px;
`;

export const ErrorFileLabel = styled(Typography)`
  margin: 3px 14px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.66;
  text-align: left;
  letter-spacing: 0.5px;
  color: ${mainTheme.palette.error.main};
`;
